import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_OLD, offerIncludes, offerRows } from '../data/religione';
import { REAL_MOCKUP as PRODUCT_IMAGE } from '../data/realImages';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-231" data-mp="1hofsa5aetvca">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-232" data-mp="tyldhi6j5wpe">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-233" data-mp="u0oaim63oq3m">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-234" data-mp="p11z8i9u1jxg">
            Scopri il tuo pacchetto completo <em className="text-red-300" data-id="element-235" data-mp="13uy4u9elrygz">RELIGIONE PRONTA™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-236" data-mp="ywd488vfvcs0">
            Le tue lezioni di religione pronte in soli 5 minuti. Entra in aula con tutto pronto.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-237" data-mp="2acbhyq1kamzk" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-238" data-mp="pmbgpus6v45i">
          <img src={PRODUCT_IMAGE} alt="RELIGIONE PRONTA™: 6 tomi + 5 bonus" className="mx-auto mb-6 w-full max-w-[16rem] drop-shadow-xl lg:hidden" data-id="element-239" data-mp="zi54697g4i22" />
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-240" data-mp="13hvyuo03fibv">Il pacchetto completo contiene</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-241" data-mp="6rmsijsnp8d1">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-242" data-mp="fufj0ku0lg1t">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-243" data-mp="fsuq0zncm562">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-244" data-mp="kn8oxc17yufh" />
                </span>
                <span data-id="element-245" data-mp="3oa7k2xbybdl7">
                  <span className="block font-medium leading-snug" data-id="element-246" data-mp="3o9pj5necgb6y">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-247" data-mp="vfh7gflvv7n1">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-248" data-mp="qge20u1zqzej">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-249" data-mp="105xk3xhvqp8c">
              Prezzo di lancio <span className="ml-1 text-slate-900/50" data-id="element-250" data-mp="cgmo0tbh5j0j">invece di <s data-id="element-251" data-mp="chejm452ngqt">{PRICE_OLD}</s></span>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-252" data-mp="7ibfqn0tvgkf">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-253" data-mp="lfgiad1c1xax">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-254" data-mp="hic3qm9n6kuy" />
            Pagamento unico. Nessun abbonamento.
          </p>

          <CtaButton label="Voglio il pacchetto completo" className="mt-8 w-full" data-id="element-255" data-mp="1svnzsaz5tz6k" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-256" data-mp="20ex9k5bkvzw5">
            {offerIncludes.map(item => <li key={item} data-id="element-257" data-mp="25erxq13yybdi">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}